/**
 * Phone-vs-not detection for the face-scan capture gate
 * (DEV_SPEC_desktop_capture_warning.md §4). The photo capture is phone-only:
 * desktop, laptop AND tablets (incl. iPad, incl. iPadOS-13+ reporting as
 * desktop Safari) are gated to the phone handoff. Combination check, not UA
 * alone; when ambiguous, default to gating (protects capture quality).
 */
export function isPhone(): boolean {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || '';

  if (/iPhone|iPod|Windows Phone/i.test(ua)) return true;

  // iPad — including iPadOS 13+ which reports as desktop Safari — is a tablet,
  // NOT a phone.
  if (/iPad/i.test(ua)) return false;
  if (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1) {
    return false; // iPad on iPadOS 13+
  }

  // Android: phone Chrome UA includes the "Mobile" token; tablets usually omit it.
  if (/Android/i.test(ua)) return /Mobile/i.test(ua);

  // Fallback: coarse pointer + narrow physical screen = phone.
  const minDim = Math.min(window.screen.width, window.screen.height);
  const coarse =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches;
  return coarse && minDim <= 500;
}

/** true for desktop AND tablet — i.e. gate the face-scan capture to phone. */
export function shouldGateCaptureToPhone(): boolean {
  return !isPhone();
}
